import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage",
    desc: "Pose sur sols et murs, anciens ou neufs. Carrelage grand format, joints fins, finitions propres pour des intérieurs modernes et durables.",
    imgPosition: "object-bottom",
    img: "/images/services-pose.jpg",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain",
    desc: "Transformation complète de votre salle de bain : démolition, plomberie, carrelage, mobilier. Un espace repensé selon vos envies.",
    img: "/images/services-renovation.jpg",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne",
    desc: "Création de douches à l'italienne sur mesure. Receveur de douche, paroi vitrée, carrelage antidérapant — esthétique et fonctionnel.",
    img: "/images/services-douche.jpg",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque",
    desc: "Pose de faïence murale et mosaïque pour crédences, salles de bain, piscines. Motifs choisis avec vous et matériaux adaptés à l'usage.",
    img: "/images/services-faience.jpg",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur",
    desc: "Terrasses, allées, piscines — carrelage extérieur antidérapant et résistant aux intempéries. Esthétique durable pour vos espaces outdoor.",
    imgPosition: "object-bottom",
    img: "/images/services-exterieur.jpg",
  },
  {
    icon: "ri-tools-line",
    title: "Petits espaces",
    desc: "Optimisation de studios, WC, buanderies. Chaque centimètre compte — nous maximisons l'espace avec des solutions créatives et pratiques.",
    img: "/images/services-petits-espaces.jpg",
  },
];

export default function ServicesSection() {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Ce que nous faisons</span>
          <h2 className="mt-3 text-4xl font-bold text-stone-900">Nos <strong>Services</strong></h2>
          <p className="mt-4 text-stone-500 max-w-xl mx-auto text-sm leading-relaxed">
            On ne fait pas tout, mais ce qu'on fait, on le fait bien. Carrelage, salle de bain, douche à l'italienne — le travail au millimètre près.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service) => (
            <div
              key={service.title}
              className="group bg-white rounded-lg overflow-hidden border border-stone-100 hover:border-amber-200 transition-all duration-300"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.img}
                  alt={service.title}
                  className={`w-full h-full object-cover ${service.imgPosition ?? 'object-top'} group-hover:scale-105 transition-transform duration-500`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-3 left-4 w-9 h-9 flex items-center justify-center bg-amber-700 rounded-lg">
                  <i className={`${service.icon} text-white text-lg`}></i>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed mb-4">{service.desc}</p>
                <Link
                  to="/services"
                  className="inline-flex items-center gap-1.5 text-sm text-amber-700 font-medium hover:gap-2.5 transition-all"
                >
                  En savoir plus <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-stone-900 text-white font-medium rounded-full hover:bg-amber-700 transition-colors whitespace-nowrap"
          >
            Voir tous nos services
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}